import React from 'react'
import DropboxChooser from 'react-dropbox-chooser'
import DropboxIcon from '../../../../assets/icons/dropbox.svg'
import {toaster} from '../../../../shared/PFToast'

const APP_KEY = process.env.REACT_APP_DROPBOX_API_KEY || ''

const UploadByDropbox = ({onFileSelect}) => {
    function handleSuccess(files) {
        const fileMeta = files[0]

        fetch(fileMeta.link)
            .then((res) => res.blob())
            .then((blob) => {
                const file = new File([blob], fileMeta.name, {type: blob.type})
                onFileSelect([file])
            })
            .catch((err) => {
                console.error('Error downloading Dropbox file', err)
                toaster({
                    type: 'error',
                    message: 'An error occurred while uploading the image',
                    duration: 10000,
                    width: 370,
                })
            })
    }
    return (
        <DropboxChooser
            appKey={APP_KEY}
            success={handleSuccess}
            extensions={['.png', '.jpg', '.svg', '.jpeg']}
            linkType="direct"
            folderselect={true}
            multiselect={false}
        >
            <label
                htmlFor="inputUploadArtwork_computer11"
                id="inputUploadArtwork_computer11"
                className="mb-0 cursor-pointer align-items-center"
            >
                <img src={DropboxIcon} alt="dropbox-icon" className="mr-2" />
                Dropbox
            </label>
        </DropboxChooser>
    )
}

export default UploadByDropbox

